import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomeThree from "./pages/home-3";
import NoPage from "./pages/NoPage";
import CFPPage from "./pages/cfp";
import CTFPage from "./pages/ctf";
import EventRegisterPage from "./pages/event-register";
import AboutUsPage from "./pages/about-us";
import BsidesContact from "./pages/bsides-contact";
import SpeakersPage from "./pages/speakers";
import CommunityEventsPage from "./pages/community-events";
import SchedulePage from "./pages/schedule";
import VolunteersPage from "./pages/volunteers";
import TrainingsPage from "./pages/trainings";
import TrainingDetail from "./pages/trainings/TrainingDetail";
import WhatsAppButton from "./components/WhatsAppButton";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import ProtectedRoute from "./components/ProtectedRoute";

export default function App() {
  return (
    <BrowserRouter>
      <WhatsAppButton />
      <Routes>
        <Route index element={<HomeThree />} />
        <Route path="home-3" element={<HomeThree />} />
        <Route path="cfp" element={<CFPPage />} />
        <Route path="ctf" element={<CTFPage />} />
        <Route path="join" element={<EventRegisterPage />} />
        <Route path="about-us" element={<AboutUsPage />} />
        <Route path="bsides-contact" element={<BsidesContact />} />
        <Route path="speakers" element={<SpeakersPage />} />
        <Route path="community-events" element={<CommunityEventsPage />} />
        <Route path="schedule" element={<SchedulePage />} />
        <Route path="volunteers" element={<VolunteersPage />} />
        <Route path="trainings" element={<TrainingsPage />} />
        <Route path="trainings/:trainingId" element={<TrainingDetail />} />
        
        {/* Admin Routes */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        } />

        <Route path="*" element={<NoPage />} />
      </Routes>
    </BrowserRouter>
  );
}
